import { InlineSpinner } from "./inline-spinner";

interface WorkBreakResumeProps {
  isOnBreak: boolean;
  loading?: boolean;
  onResume?: () => void;
  onBeginWork?: () => void;
}

export default function WorkBreakResume({ 
  isOnBreak, 
  loading = false, 
  onResume, 
  onBeginWork 
}: WorkBreakResumeProps) {
  if (isOnBreak) {
    return (
      <div className="row">
        <div className="col text-center mt-5">
          <h1>RESUME</h1>
          <div className="mb-3">Click resume to begin</div>
          <button
            type="button"
            className="btn btn-sw mb-5"
            onClick={onResume}
            disabled={!onResume}
          >
            {loading && <InlineSpinner />}
            Resume
          </button>
        </div>
      </div>
    );
  }

  if (onBeginWork) {
    return (
      <div className="row">
        <div className="col text-center mt-5">
          <h1>BEGIN TASK</h1>
          <div className="mb-3">Click continue to begin a set of tasks</div>
          <button
            type="button"
            className="btn btn-sw mb-5"
            disabled={loading}
            onClick={onBeginWork}
          >
            {loading && <InlineSpinner />}
            Continue
          </button>
        </div>
      </div>
    );
  }

  return null;
}